var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "wkb-mechanism-association-scores" },
    [
      _c("h4", { staticClass: "wkb-mechanism-association-scores-title" }, [
        _vm._v("Association scores"),
      ]),
      _c("p", { staticClass: "wkb-mechanism-association-scores-lead" }, [
        _vm._v(" For connected genes and traits on the graph. "),
      ]),
      _vm.loading
        ? _c("p", { staticClass: "wkb-inspector-note" }, [
            _c("span", {
              staticClass: "wkb-inspector-spinner",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" Loading association scores… "),
          ])
        : _vm.error
        ? _c(
            "p",
            { staticClass: "wkb-inspector-note wkb-inspector-note--warn" },
            [_vm._v(" " + _vm._s(_vm.error) + " ")]
          )
        : _vm.summary
        ? [
            _c(
              "p",
              {
                staticClass:
                  "wkb-inspector-note wkb-mechanism-association-scores-summary",
              },
              [
                _c("strong", [_vm._v("Genes scored:")]),
                _vm._v(" " + _vm._s(_vm.summary.geneRows.length) + ". "),
                _c("strong", [_vm._v("Traits scored:")]),
                _vm._v(" " + _vm._s(_vm.summary.traitRows.length) + ". "),
                _c("strong", [_vm._v("Gene sets:")]),
                _vm._v(" " + _vm._s(_vm.summary.geneSetRows.length) + ". "),
              ]
            ),
            _c("WorkspaceEvidenceTable", {
              attrs: {
                title: "Mechanism × gene loadings",
                rows: _vm.summary.geneRows,
                columns: _vm.geneColumns,
                "pagination-label": "Mechanism gene loading pages",
              },
            }),
            _c("WorkspaceEvidenceTable", {
              attrs: {
                title: "Mechanism × trait relevance",
                rows: _vm.summary.traitRows,
                columns: _vm.traitColumns,
                "pagination-label": "Mechanism trait score pages",
              },
            }),
            _vm.summary.geneSetRows.length
              ? _c("WorkspaceEvidenceTable", {
                  attrs: {
                    title: "Top mechanism gene sets",
                    rows: _vm.summary.geneSetRows,
                    columns: _vm.geneSetColumns,
                    "page-size": 10,
                    "pagination-label": "Mechanism gene set pages",
                  },
                })
              : _vm._e(),
          ]
        : _c("p", { staticClass: "wkb-inspector-note" }, [
            _vm._v(
              " No association scores were returned for connected genes or traits on this graph. "
            ),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }